module.exports = __webpack_public_path__ + "img/arrow-left-grey.ba8e25f8.svg";